const swiper = new Swiper("#product-gallery", {
  loop: true,
  pagination: {
    el: ".swiper-pagination",
  },
});

$(document).ready(function () {
  $("#sustainability slider-component")
    .addClass("swiper")
    .append('<div class="swiper-pagination"></div>');
  $("#sustainability .multicolumn-list")
    .addClass("swiper-wrapper")
    .removeClass("grid grid--1-col-tablet-down grid--2-col-desktop");
  $("#sustainability .multicolumn-list li").addClass("swiper-slide");

  setTimeout(function () {
    const swiper2 = new Swiper(".related-product-wrapper", {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 30,
        },
      },
    });

    const swiper3 = new Swiper("#sustainability .swiper", {
      slidesPerView: 1,
      spaceBetween: 25,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        700: {
          slidesPerView: 2,
        },
      },
    });
  }, 2000);
localStorage.getItem("pwd");
  if (localStorage.getItem("pwd") != null) {
     //console.log("value");
    $("#HeaderMenu-shop").attr("href", localStorage.getItem("pwd"));
    $("#HeaderDrawer-shop").attr("href", localStorage.getItem("pwd"));
    $(".title-wrapper-with-link a.underlined-link").attr("href", localStorage.getItem("pwd"));
    $(".shop_now_sec a").attr("href", localStorage.getItem("pwd"));
  }

  var passurl = "";

  function getSchool(e) {
    var arbor_school = $("#arbor").val();
    var fairgreen_school = $("#fairgreen").val();
    var nadeed_school = $("#nadeed").val();
    var cheltenham_muscat = $("#cheltenham_muscat").val();
    var bisj = $("#bisj").val();
    var customer = $("#search-schools").attr("user");
    var userMail = $("#search-schools").attr("mail");
    //console.log(UserMail);
    if (customer == "login") {
      if ($(".school-code").val() == "") {
        return;
      }
      //console.log(arbor_school);
      var school_code = $(".school-code").val();

      if (
        school_code == arbor_school &&
        userMail != "catalinasilesky@gmail.com"
      ) {
        //console.log("go to arbor");
        $("#search-schools .wrong_code").hide();
        $("#search-schools form").removeClass("active");
        window.location.replace(
          "https://www.kapesuniforms.com/collections/arbor-school"
        );
        passurl = "https://www.kapesuniforms.com/collections/arbor-school";
        localStorage.setItem(
          "pwd",
          "https://www.kapesuniforms.com/collections/arbor-school"
        );
        return;
      } else if (school_code == fairgreen_school) {
        //console.log("go to fairgreen");
        $("#search-schools .wrong_code").hide();
        $("#search-schools form").removeClass("active");
        window.location.replace(
          "https://www.kapesuniforms.com/collections/fairgreen-international"
        );
        passurl =
          "https://www.kapesuniforms.com/collections/fairgreen-international";
        localStorage.setItem(
          "pwd",
          "https://www.kapesuniforms.com/collections/fairgreen-international"
        );

        return;
      } else if (school_code == cheltenham_muscat) {
        //console.log("go to cheltenham-muscat");
        $("#search-schools .wrong_code").hide();
        $("#search-schools form").removeClass("active");
        let url="https://89d281-37.myshopify.com?authorization=zenda&auth_code=CHEL8937";
        
        passurl =
          "https://89d281-37.myshopify.com/collections/cheltenham-muscat";
        localStorage.setItem(
          "pwd",
          "https://89d281-37.myshopify.com/collections/cheltenham-muscat"
        );

        window.location.replace(
          url
        );

        return;  
      } else if (school_code == bisj) {
        //console.log("go to bisj");
        $("#search-schools .wrong_code").hide();
        $("#search-schools form").removeClass("active");
        window.location.replace(
          "https://www.kapesuniforms.com/collections/bisj"
        );
        passurl =
          "https://www.kapesuniforms.com/collections/bisj";
        localStorage.setItem(
          "pwd",
          "https://www.kapesuniforms.com/collections/bisj"
        );
// setInterval(function() {
//     $(".product__info-wrapper").each(function(){
//         var priceElement = $(this).find(".price__container .price-item.price-item--regular .money");
//         var price = priceElement.text().trim(); // Trim whitespace

//         if (price.slice(-2) === "SR") {
//             price = price.slice(0, -2) + "SAR";
//         }

//         priceElement.text(price);
//         //console.log(price);
//     });
// }, 1000); 
        
        return;   
      } else if (school_code == nadeed_school) {
        //console.log("go to nadeed_school");
        $("#search-schools .wrong_code").hide();
        $("#search-schools form").removeClass("active");
        window.location.replace(
          "https://www.kapesuniforms.com/collections/nadeen-school"
        );
        passurl = "https://www.kapesuniforms.com/collections/nadeen-school";
        localStorage.setItem(
          "pwd",
          "https://www.kapesuniforms.com/collections/nadeen-school"
        );
        return;
      } else {
        //console.log("stop here");
        //console.log("Entered Code Is Wrong, Please Enter Correct Code");
        $("#search-schools .wrong_code").show();
        $("#search-schools form").addClass("active");
        return;
      }
      $("#search-schools .alert").hide();
      $("#search-schools form").removeClass("active");
    } else {
      //console.log("stop");
      $("#search-schools .alert").show();
      $("#search-schools form").addClass("active");
      if (localStorage.getItem("pwd") != null) {
        //console.log("value");
        $("#HeaderMenu-shop").attr("href", localStorage.getItem("pwd"));
        $("#HeaderDrawer-shop").attr("href", localStorage.getItem("pwd"));
        $(".cart__warnings a").attr("href", localStorage.getItem("pwd"));
        $(".shop_now_sec a").attr("href", localStorage.getItem("pwd"));
      }
      //window.location.replace("https://www.kapesuniforms.com/customer_identity/redirect");
      window.location.replace(
        "https://shopify.com/77733265724/auth/lookup?destination_uuid=14a3623b-bee7-4a31-9dab-219b335cd744&redirect_uri=https%3A%2F%2Faccount.kapesuniforms.com"
      );
      return;
    }

    // Retrieve
    document.getElementById("tests").innerHTML = localStorage.getItem("pwd");
    $("#HeaderMenu-shop").attr("href", localStorage.getItem("pwd"));
    //       $.each( $('.custom-collections li'), function(index, value) {
    //         if ( $(value).data('schoolcode') == '' ) {
    // console.log(value);

    //           return;
    //         }

    //         if ( $(value).data('schoolcode') == school_code ) {
    //           window.location.replace($(value).data('url'));
    //         }
    //       });
  }

  $("#search-schools button#entre").click(function(e){
    e.preventDefault();
    getSchool();
  });
  
  $("#search-schools form").submit(function(e){
    e.preventDefault();
    getSchool();
  });

  $("#video_content_light .lightbox-btn").click(function () {
    var video_url = $(this).data("video");

    $("#video_lightbox iframe").attr("src", video_url);
    $("#video_lightbox").addClass("active");
  });

  $("#video_lightbox .modal-bg").click(function () {
    $("#video_lightbox").removeClass("active");
    $("#video_lightbox iframe").attr("src", "");
  });

  if ($(window).width() < 767) {
    $("#foot-4 slider-component")
      .addClass("swiper")
      .append('<div class="swiper-pagination"></div>');
    $("#foot-4 .multicolumn-list")
      .addClass("swiper-wrapper")
      .removeClass("grid grid--1-col-tablet-down grid--2-col-desktop");
    $("#foot-4 .multicolumn-list li")
      .addClass("swiper-slide")
      .removeClass("grid__item");

    setTimeout(function () {
      const swiper3 = new Swiper("#foot-4 .swiper", {
        slidesPerView: 1,
        spaceBetween: 25,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }, 2000);
  }

  $(".icon-with-text__item a").click(function (e) {
    e.preventDefault();

    $(".popup-size").addClass("active");
  });

  $(".popup-size .bg-overlay").click(function () {
    $(".popup-size").removeClass("active");
  });

  $("#size-tab li").click(function () {
    var current_tab = $(this).attr("data-type");

    $("#size-tab li").removeClass("active");
    $(this).addClass("active");

    $("#size-content > div").removeClass("active");
    $('#size-content > div[data-content="' + current_tab + '"]').addClass(
      "active"
    );
  });

  $("#materials-2 .multicolumn-list__item a").click(function (e) {
    e.preventDefault();

    $("#organic-cotton, #wood, #recycled-bottles").hide();
    $(".material-4").hide();

    $("#materials-2 .multicolumn-list__item").removeClass("active");

    if ($(this).parents(".multicolumn-list__item").hasClass("organic-cotton")) {
      $("#organic-cotton").slideDown();
      $("#organic-know").slideDown();
    }

    if ($(this).parents(".multicolumn-list__item").hasClass("wood")) {
      $("#wood").slideDown();
      $("#wood-know").slideDown();
    }

    if (
      $(this).parents(".multicolumn-list__item").hasClass("recycled-bottles")
    ) {
      $("#recycled-bottles").slideDown();
      $("#recycled-know").slideDown();
    }
    $(this).parents(".multicolumn-list__item").addClass("active");
  });

// popup
  $(".code_help_modal .modal_content p.close_icon, .code_help_modal .overlay").click(function () {
$(".code_help_modal").hide();
})
  $("p.need_help").click(function () {
$(".code_help_modal").show();
})
setTimeout(function(){
var shop_val = $("#HeaderMenu-shop").attr("href");
$(".shop_now_sec a").attr("href", localStorage.getItem("pwd"));
},300);


if (localStorage.getItem("pwd") === "https://www.kapesuniforms.com/collections/bisj") {
        document.body.classList.add("bisj-coll");
    }else{
        document.body.classList.add("bisj-cnot");
    }

});
